module.exports = __webpack_public_path__ + "origin-order1-check.6c615d4a11340209717c.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/assets/vcg/img/origin-order1-check.svg
// module id = ../../../../../src/assets/vcg/img/origin-order1-check.svg
// module chunks = styles